/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desired_Tech_SkillsInputs */

const en_desired_tech_skills = /** @type {(inputs: Desired_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desired Tech Skills`)
};

const de_desired_tech_skills = /** @type {(inputs: Desired_Tech_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewünschte Tech-Skills`)
};

/**
* | output |
* | --- |
* | "Desired Tech Skills" |
*
* @param {Desired_Tech_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const desired_tech_skills = /** @type {((inputs?: Desired_Tech_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desired_Tech_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_desired_tech_skills(inputs)
	return en_desired_tech_skills(inputs)
});